import React, { useState, useEffect } from "react";
import { Box, Container, Grid, Skeleton } from "@common-ui/ui";

import { useHistory } from "react-router-dom";

import { getUserOrgs, listToTree } from "../../services";
import { OrgsTreeView } from "./OrgsTreeView";
import { ViewSingleOrg } from "./ViewSingleOrg";
export const UserOrgsTreeViewWrapper = () => {
  let router = useHistory();
  const [rowsData, setRowsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [unfilteredData, setUnfilteredData] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    try {
      let rowsData = await getUserOrgs();
      setUnfilteredData(rowsData);
      setRowsData(listToTree(rowsData));
      setIsLoading(false);
    } catch (error) {
      alert(error);
      setIsLoading(false);
    }
  }

  return (
    <>
      <Box
        component="main"
        sx={{
          alignItems: "center",
          display: "flex",
          flexGrow: 1,
          minHeight: "100%",
          backgroundColor: "#FFFFFF",
          ".MuiDataGrid-virtualScroller": {
            marginTop: "40px !important",
          },
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
          // bgcolor: "background.paper",
        }}
      >
        <Container maxWidth="xl" component="main" sx={{ my: 2 }}>
          <Grid container spacing={2}>
            <Grid item md={3}>
              <Box sx={{ position: "sticky", top: "calc(55px)" }}>
                {isLoading ? (
                  Array.from(new Array(8)).map((item, i) => (
                    <Skeleton variant="text" height={45} width={300} key={i} />
                  ))
                ) : (
                  <OrgsTreeView orgs={rowsData} router={router} />
                )}
              </Box>
            </Grid>
            <Grid md={8} item={true}>
              <Box sx={{ position: "sticky" }}>
                <ViewSingleOrg unfilteredData={unfilteredData} />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};
